import { EventEmitter, Injectable, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpEvent } from '@angular/common/http';
import { 
  DocumentStatut,
  DocTyp,
  PafDocument,
  SimpleReponseResult,
  SupplierDocument,
  PS_Supplier_Regul_Docs_Result,
  PS_Supplier_Qual_Docs_2_Result,
  ChangeStatutParams,  
  PS_Supplier_Archive_Docs_Result,
  PS_Supplier_Purchase_Docs_Result
} from '../all-models';
import { map } from 'rxjs/operators';
import { SharedDataService } from './shared-data/shared-data.service';


@Injectable({
  providedIn: 'root'
})
export class DocumentsService {
  docsUrl: string

  constructor(private http: HttpClient, private sharedDataSvc: SharedDataService) {
this.docsUrl = this.sharedDataSvc.apiBaseUrl + 'Documents/'
  }



  PostImportAvisSituationFromSirene(supplierId: number): Observable<SimpleReponseResult> {
    return this.http.post<SimpleReponseResult>(`${this.docsUrl}ImportAvisSituationFromSirene/${supplierId}`, null);
  }

  getPafDocuments(): Observable<PafDocument[]> {
    return this.sharedDataSvc.listsSvc.getPafDocuments();
  }

  getDocTyps(): Observable<DocTyp[]> {
    return this.sharedDataSvc.listsSvc.getDocTyps();
  }

  getDocumentStatuts(): Observable<DocumentStatut[]> {
    return this.sharedDataSvc.listsSvc.getDocumentStatuts();
  }

  getSupplierDocuments(supplierId: number, docId: number = 0): Observable<SupplierDocument[]> {
    return this.http.get<SupplierDocument[]>(`${this.docsUrl}Suppliers/${supplierId}/SupplierDocuments/${docId}`);
  }

  getSupplierRegulDocs(lngCod: string, supplierId: number, externalRefresh: boolean = true): Observable<PS_Supplier_Regul_Docs_Result[]> {
    return this.http.get<PS_Supplier_Regul_Docs_Result[]>(`${this.docsUrl}SupplierRegulDocs/${lngCod}/${supplierId}/${externalRefresh}`);
  }

  getSupplierRegulDoc(lngCod: string, supplierId: number, docId: number): Observable<PS_Supplier_Regul_Docs_Result> {
    return this.http.get<PS_Supplier_Regul_Docs_Result[]>(`${this.docsUrl}SupplierRegulDocs/${lngCod}/${supplierId}`)
      .pipe(
        map(data => data.find(d => d.DocId == docId))
      );
  }

  getSupplierQualDocs(lngCod: string, supplierId: number): Observable<PS_Supplier_Qual_Docs_2_Result[]> {
    return this.http.get<PS_Supplier_Qual_Docs_2_Result[]>(`${this.docsUrl}SupplierQualDocs/${lngCod}/${supplierId}`);
  }

  getSupplierQualDoc(lngCod: string, supplierId: number, docId: number): Observable<PS_Supplier_Qual_Docs_2_Result> {
    return this.http.get<PS_Supplier_Qual_Docs_2_Result[]>(`${this.docsUrl}SupplierQualDocs/${lngCod}/${supplierId}`)
    .pipe(
      map(data => data.find(d => d.DocId == docId))
    );
  }

  getSupplierPurchaseDocs(supplierId: number): Observable<PS_Supplier_Purchase_Docs_Result[]> {
    return this.http.get<PS_Supplier_Purchase_Docs_Result[]>(`${this.docsUrl}SupplierPurchaseDocs/${supplierId}`);
  }

  downloadFile(supplierId: number, docId: number): Observable<any> {
    let getOptions: any = { responseType: 'blob' };
    return this.http.get<any>(`${this.docsUrl}Suppliers/${supplierId}/Documents/${docId}/Download`,
      getOptions);
  }

  downloadTemplate(pafDocId: number, supplierId: number = 0): Observable<any> {
    let getOptions: any = { responseType: 'blob' };
    let optionSupplier:string = supplierId!=0 ? `/${supplierId}`:'';
    return this.http.get<any>(`${this.docsUrl}/PafDocuments/${pafDocId}/DownloadTemplate${optionSupplier}`,
      getOptions);
  }

  public uploadFile(supplierId: number, docId: number, formData: any): Observable<any> {
    return this.http.post<any>(`${this.docsUrl}Suppliers/${supplierId}/Documents/${docId}/Upload`, formData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  public uploadFileWithRefDoc(supplierId: number, refDocId: number, dateInput : Date| undefined, description : string| undefined,file: File,overwriteIfExists: boolean=false): Observable<SimpleReponseResult> {
    const formData = new FormData(); 
    formData.append("file", file);
    if (dateInput) formData.append("dateInput", dateInput.toLocaleDateString());
    formData.append("description", description);
    formData.append("overwriteIfExists", overwriteIfExists.toString());
    return this.http.post<SimpleReponseResult>(`${this.docsUrl}Suppliers/${supplierId}/Documents/UploadFileWithRefDoc/${refDocId}`, formData);
  }
  
  public uploadQualityFile(supplierId: number, refDocId: number, docId:number = 0, formData: any): Observable<any> {

    return this.http.post<any>(`${this.docsUrl}Suppliers/${supplierId}/QualityDocuments/${refDocId}/Upload/${docId}`, formData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  public uploadPurchaseFile(purchaseDoc:PS_Supplier_Purchase_Docs_Result, formData: any): Observable<any> {
    return this.http.post<any>(`${this.docsUrl}Suppliers/${purchaseDoc.SupplierId}/PurchaseDocuments/${purchaseDoc.RefDocId}/Upload`, formData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  public deleteFile(supplierId: number, docId: number): Observable<SimpleReponseResult> {
    return this.http.post<SimpleReponseResult>(`${this.docsUrl}Suppliers/${supplierId}/Documents/${docId}/Delete`, null);
  }

  public deleteQualityFile(supplierId: number, docId: number): Observable<SimpleReponseResult> {
    return this.http.post<SimpleReponseResult>(`${this.docsUrl}Suppliers/${supplierId}/QualityDocuments/${docId}/Delete`, null);
  }
  
  importAction(action: string): Observable<SimpleReponseResult> {
    return this.http.post<SimpleReponseResult>(`${this.docsUrl}${action}`, null);
  }

  public ChangeStatut(supplierId: number, params:ChangeStatutParams ): Observable<SimpleReponseResult> {
    return this.http.post<SimpleReponseResult>(`${this.docsUrl}Suppliers/${supplierId}/ChangeStatut`, params);
  }

  public getArchiveDocList(supplierId:number,lngCod:string) : Observable<PS_Supplier_Archive_Docs_Result[]>{
    return this.http.get<PS_Supplier_Archive_Docs_Result[]>(`${this.docsUrl}Suppliers/${supplierId}/ArchiveDocList/${lngCod}`);
  }
  

  public DownloadDematConditionsFile(): Observable<any> {
    return this.downloadTemplate(60);
  }
}
